/*
 Created by CHT 2019/8/26 11:39
 */
export const SUCCESS = 0
export const ERROR = -1
export const REQUEST_UN_REG = 33001 // 账号或密码错误

export const ACCOUNT_EXIST_ERROR  = 50010001 // 账号已经存在
export const ACCOUNT_NOT_MATCH_ERROR = 50010002 // 账号密码不匹配
export const ACCOUNT_NOT_EXIST_ERROR  = 50010003 // 账号不存在
export const TICKET_NOT_OK_ERROR = 50010004 // 无效的ticket
export const PWD_NOT_SAME_AS_OLD_ERROR = 50010005 // 新老密码不能重复
export const PHONE_CODE_ERROR = 50010006 // 验证码错误
export const ACCOUNT_STATUS_ERROR  = 50010007 // 账号状态异常
export const LOGIN_QRCODE_GENEREATE_ERROR  = 50010008 // 登录二维码生成错误
export const BINDING_QRCODE_GENEREATE_ERROR = 50010009 // 绑定二维码生成错误

export const SYS_APP_NAME_EMPTY_ERROR = 50020001 // APP名称不能为空
export const SYS_APP_NAME_EXIST_ERROR  = 50020002 // APP名称已经存在

export const ROLE_NAME_REPEAT_ERROR  = 50030001 // 角色名称 重复
export const DEP_NAME_REPEAT_ERROR  = 50030002 // 部门名称重复
export const DEP_HAS_MEMBER_ERROR  = 50030003 // 部门或者子部门有成员 不能删除
export const COMPANY_DEP_CAN_NOT_DELETE_ERROR = 50030004 // 公司层级不能删除
export const NOT_COMPANY_TOP_ADMIN_ERROR  = 50030005 // 不是公司主管理员
export const NOT_COMPANY_MEMBER_ERROR  = 50030006 // 不是公司成员
export const DEP_NOT_EXIST_ERROR  = 50030007 // 部门信息不存在
export const COMPANY_NOT_EXIST_ERROR = 50030008 // 公司信息不存在
export const PERMISSION_DEFINE_ERROR = 50030009 // 无权限
export const ROLE_NOT_EXIST_ERROR  = 50030010 // 角色信息不存在

export const FORM_SUBMIT_ERROR = 500360002 // 表单提交校验失败

export const FORM_FLOW_NOT_INIT = 50040005  // 表单流程没有初始化

export const FORM_STEP_PERMISSION_NOT_INIT_ERROR  = 50040015 //  表单流程权限未设置
export const FORM_INSTANCE_NOT_EXIST = 50040022 // 表单数据实例不存在
export const FORM_WRITE_FIELD_REPEAT  = 50040033 // 填写表单value字段重复

export const LINK_POSTING_FORIF = 500160001 // 外链不存在或者已关闭
export const LINK_POSTING_PASSWORD_ERROR = 500160002 // 外链密码错误

export const NOT_FEATURE = 500180001 // 权益不足，无法使用
export const FEATURE_OVERCLOCKING = 500180002 // 权益消费速度超出频率限制

export const INVOICE_INFO_NOT_EXIST = 500210001 // 开票信息不存在

/**
 * 已经是公司成员了
 */
export const ALREADY_COMPANY_MEMBER_ERROR = 50030017
/**
 * 已经是公司外部联系人了
 */
export const ALREADY_COMPANY_EXTERNAL_CONTACT_ERROR = 50030018
/**
 * 邀请码不存在
 */
export const INVITE_CODE_NOT_EXIST_ERROR = 50030026;
/**
 * 邀请码已过期
 */
export const INVITE_CODE_EXPIRE_ERROR = 50030027;

export const CREAT_EVENT_FORM_EXIST = 500200002; // App下已经存在表单分组

export const CHECK_CODE_ERROR = 50010006; // 手机控件字段验证验证码错误


export const FORM_STATUS__READ = 0 // 读取状态
export const FORM_STATUS__FILL = 1 // 输入状态
export const FORM_STATUS__EDIT = 2 // 设置状态

/**
 * 提交服务器的表单状态
 * @type {number}
 */
export const FORM_TYPE__EDIT = 0 // 编辑
export const FORM_TYPE__FILL = 1 // 填写


/**
 * 表单权限
 * @type {number}
 */
export const PERMISSION__EDITOR = 6    // 写
export const PERMISSION__READ = 2      // 只读
export const PERMISSION__HIDDEN = 0    // 隐藏


/**
 * 数据类型 dataType
 * @type {string}
 */
export const DATA_TYPE__DEFAULT = 'default'
export const DATA_TYPE__STRING = 'String'
export const DATA_TYPE__NUMBER = 'Number'
export const DATA_TYPE__LONG = 'Long'
export const DATA_TYPE__ARRAY = 'Array'
export const DATA_TYPE__JSON = 'Json'
export const DATA_TYPE__BUTTON = 'button'


/**
 * 默认数据 defaultValue
 * @type {string}
 */
export const DEFAULT_VALUE__CUSTOM = 'custom' 					   // 自定义
export const DEFAULT_VALUE__ID = 'id' 					   // 自动生成唯一标识符
export const DEFAULT_VALUE__CREATE_TIME = 'createTime' 		 // 日期控件 - 默认提交时间
export const DEFAULT_VALUE__FORMULA = 'formula'					   // 公式
export const DEFAULT_VALUE__RELATE_DATA = 'relateData'	   // 关联已有数据
export const DEFAULT_VALUE__RELATE_DATA_NEW = 'relateDataNew'	   // 关联已有数据新版
export const DEFAULT_VALUE__DATE_INTERVAL = 'dateInterval' // 日期区间 dateInterval
export const DEFAULT_VALUE__CHOOSE = 'choose'              // 选择框 choose
export const DEFAULT_VALUE__IMAGE = 'image'                // 图片 image
export const DEFAULT_VALUE__FILE = 'file'                  // 文件 file
export const DEFAULT_VALUE__MEMBER = 'memberAndDept'       // 成员和部门 member
export const DEFAULT_VALUE__CURRENT_MEMBER = 'current_member'  // member控件默认值为当前成员
export const DEFAULT_VALUE__DEPARTMENT = DEFAULT_VALUE__MEMBER
export const DEFAULT_VALUE__ADDRESS = 'address'            // 地址 address
export const DEFAULT_VALUE__SUB_TABLE_ID = 'serialNo' 					   // 自动生成唯一标识符


/**
 * 金额单位
 * @type {string}
 */
export const CURRENCY_TYPE__DOLLAR = 'DOLLAR'		// 美元
export const CURRENCY_TYPE__RMB = 'RMB'					// 人民币


/**
 * 编号格式
 * @type {number}
 */
export const SERIAL_NUM_TYPE__DEFAULT = 0  // 默认
export const SERIAL_NUM_TYPE__CUSTOM = 1   // 自定义


/**
 * 编号规则类型 1 数字(不足用0填充 1)  2 提交日期 3 固定文本 4 表单字段
 * @type {number}
 */
export const SERIAL_NUM_CONFIG__NUMBER = 1   // 自定计数
export const SERIAL_NUM_CONFIG__DATE = 2     // 提交日期
export const SERIAL_NUM_CONFIG__TEXT = 3     // 固定字符
export const SERIAL_NUM_CONFIG__FLIED = 4    // 表单字段

/**
 * 编号 重置周期
 * @type {number}
 */
export const SERIAL_NUM_REPEAT_PERIOD__NOT = 0    // 不重置
export const SERIAL_NUM_REPEAT_PERIOD__DAY = 1    // 日
export const SERIAL_NUM_REPEAT_PERIOD__WEEK = 2   // 周
export const SERIAL_NUM_REPEAT_PERIOD__MONTH = 3  // 月
export const SERIAL_NUM_REPEAT_PERIOD__YEAR = 4   // 年

/**
 * 编号日期选项 日期格式化类型
 * @type {number}
 */
export const SERIAL_NUM_DATE_FORMAT__YEAR = 1           // 年
export const SERIAL_NUM_DATE_FORMAT__YEAR_MONTH = 2     // 年-月
export const SERIAL_NUM_DATE_FORMAT__YEAR_MONTH_DAY = 3 // 年-月-日

/**
 * ADDRESS type
 * @type {number}
 */
export const ADDRESS_TYPE__DETAIL = 0			// 精确到详细地址
export const ADDRESS_TYPE__COUNTY = 1			// 精确到区县
export const ADDRESS_TYPE__CITY = 2				// 市
export const ADDRESS_TYPE__PROVINCE = 3		// 省


/**
 * checkbox 排列放向 展现方式
 * @type {number}
 */
export const LAYOUT_TYPE__HOR = 1  		// 横向
export const LAYOUT_TYPE__VER = 2  		// 竖向

export const SHOW_MODE__TILE = 1 			// 平铺
export const SHOW_MODE__DROP_DOWN = 2 // 下拉


/**
 * DateInput 精度
 * @type {number}
 */
export const DATE_TYPE__DAY = 0			// 精确到天
export const DATE_TYPE__SECTION = 1	// 精确到秒
export const DATE_TYPE__YEAR = 2	// 精确到年
export const DATE_TYPE__MONTH = 3	// 精确到月
export const DATE_TYPE__MINUTE = 4	// 精确到分钟


/**
 * 组件类型
 * @type {string}
 */
export const FORM_ITEM__SECTION = 'section'  // 容器

// value string 类型的组件
export const FORM_ITEM__DESCRIPTION = 'description'     // 描述文字
export const FORM_ITEM__SINGLE_LINE = 'singleline'      // 单行文本
export const FORM_ITEM__MULTILINE = 'multiline'         // 多行文本
export const FORM_ITEM__RTF = 'rtf'                     // 富文本
export const FORM_ITEM__SINGLE_CHOOSE = 'singleChoose'  // 单选
export const FORM_ITEM__DROPDOWN = 'dropdown'           // 下拉框
export const FORM_ITEM__SERIAL_NUMBER = 'serialNumber'  // 流水号
export const FORM_ITEM__EXTERNAL_DATA_SOURCE = 'externalDataSource' // 智能引用
export const FORM_ITEM__PHONE = 'phone' // 手机
export const FORM_ITEM__OUT_REQUEST = 'outRequest' // 智能连接
export const FORM_ITEM__SIGNATURE = 'signature' // 签名
export const FORM_ITEM__IFRAME = 'iframe'
export const FORM_ITEM__VIDEO = 'video'
export const FORM_ITEM__QRCODE = 'qrcode'

// value number 类型的组件
export const FORM_ITEM__NUMBER = 'number'     // 数字
export const FORM_ITEM__CURRENCY = 'currency' // 金额
export const FORM_ITEM__YES_NO = 'yesno'      // 是否
export const FORM_ITEM__GRADE = 'grade'                 // 评分
export const FORM_ITEM__SLIDING_BLOCK = 'slidingBlock'  // 滑块
export const FORM_ITEM__REALTIME_DATA = 'realTimeData' // 实时数据

// value long 类型的组件
export const FORM_ITEM__DATE = 'date'                // 日期

// value array 类型
export const FORM_ITEM__CHECKBOX = 'checkbox'        // 复选框
export const FORM_ITEM__IMAGE = 'image'              // 上传图片
export const FORM_ITEM__ATTACHMENT = 'attachment'    // 附件
export const FORM_ITEM__IMAGE_CHOOSE = 'imageChoose' // 图片选项
export const FORM_ITEM__LARK_APPROVAL = 'lark_approval' // 飞书审批链接

// value json
export const FORM_ITEM__DATE_RANGE = 'dateRange'  // 起止时间
export const FORM_ITEM__ADDRESS = 'address'       // 地址
export const FORM_ITEM__LOCATION = 'location'     // 定位
export const FORM_ITEM__MEMBER = 'member'         // 成员
export const FORM_ITEM__DEPARTMENT = 'department' // 部门
export const FORM_ITEM__SUMMARY = 'summary'       // 智能汇总
export const FORM_ITEM__FUNCTION = 'function'       // 函数字段（仪表盘字段）
export const FORM_ITEM__RELATE_RECORD = 'relateRecord' // 关联记录
export const FORM_ITEM__CURRENT_VIEW_USER = 'currentViewUser' // 当前查看人
export const FORM_ITEM__CASCADE = 'cascade' // 级联选择
//
export const FORM_ITEM__TABLE = 'table'          // 表格
export const FORM_ITEM__LINK_DATA = 'linkData'   // 关联数据
export const FORM_ITEM__LINK_QUERY = 'linkQuery' // 关联查询
export const FORM_ITEM__BUTTON = 'button'          // 按钮
export const FORM_ITEM__THIRD_DATA_TABLE = 'third_data_table' // 第三方表格
export const FORM_ITEM__THIRD_MAP = 'thirdMap' // 地图

export const FORM_ITEM__FORM_RUN_STATUS = 'formRunStatus'       // 流程状态（表单数据列表使用）
export const FORM_ITEM__FLOW_DETAIL_INFO = 'flowDetailInfo'       // 当前节点信息（表单数据列表使用）
export const FORM_ITEM__ARCHIVE = 'archiveStatus'       // 当前节点信息（表单数据列表使用）
// 增加分割线组件 2022年7月22日byzb
export const FORM_ITEM__DIVIDINGLINE = 'dividingLine'       // 分割线
/**
 * formSet title type
 * @type {number}
 */
export const FORM_TITLE_TYPE__NOT_SET = -1 // 未设置
export const FORM_TITLE_TYPE__OPTIONAL = 0 // 自选
export const FORM_TITLE_TYPE__CUSTOM = 1   // 自定义


/**
 * formSet
 * @type {string}
 */
export const AFTER_JUMP_TYPE__DEFAULT = 'DEFAULT' // 默认页面
export const AFTER_JUMP_TYPE__CUSTOM = 'CUSTOM'   // 自定义
export const AFTER_JUMP_TYPE__URL = 'URL'         // url跳转
export const AFTER_JUMP_TYPE__HTML = 'HTML'       // 展示html
export const AFTER_JUMP_TYPE__THIRD_PAGE = 'THIRD_PAGE'       // 第三方页面跳转

/**
 * 汇总方式
 * @type {number}
 */
export const SUMMARY_TYPE__SUM = 'SUM'      // 累加
export const SUMMARY_TYPE__MULTIPLY = 'MULTIPLICATION' // 累乘
export const SUMMARY_TYPE__COUNT = 'COUNT' // 计数
export const SUMMARY_TYPE__AVERAGE = 'AVERAGE' // 平均值
export const SUMMARY_TYPE__MAX = 'MAX' // 最大
export const SUMMARY_TYPE__MIN = 'MIN' // 最小
export const SUMMARY_TYPE__LATEST = 'LATEST' // 时间最晚
export const SUMMARY_TYPE__EARLIEST = 'EARLIEST' // 时间最早

/**
 * 汇总时间区间选择
 * @type {number}
 */
export const SUMMARY_TIME_CHOOSE_TYPE_EMPTY = 0 // 允许一个为空
export const SUMMARY_TIME_CHOOSE_TYPE_ALL = 1 // 不能为空

/**
 * 表单主题类型
 * @type {number}
 */
export const FORM_THEME_TYPE_COLOR = 0 // 纯色
export const FORM_THEME_TYPE_IMAGE = 1 // 图片

//------ 表单类型
export const FORM_TYPE_DIRECTORY = 0   // 表单目录
export const FORM_TYPE_FORM = 1        // 流程表单
export const FORM_TYPE_DASHBOARD = 2   // 仪表盘
export const FORM_TYPE_EVENT_FORM = 3  // 事件表单
export const FORM_TYPE_AGGREGATION = 4  // 聚合表单

/**
 * 模板状态
 * @type {number}
 */
export const TEMPLATE_STATUS_NONE = 0 // 无状态
export const TEMPLATE_STATUS_WAIT = 1 // 待审核
export const TEMPLATE_STATUS_SUC = 2 // 审核成功
export const TEMPLATE_STATUS_FAIL = 3 // 审核失败

/**
 * 模板类型
 * @type {number}
 */
export const TEMPLATE_TYPE_NONE = 0 // 全部
export const TEMPLATE_TYPE_SMS = 1 // 短信
export const TEMPLATE_TYPE_WECHAT = 2 // 微信
export const TEMPLATE_TYPE_MESSAGE = 3 // 站内信

/**
 * request字段触发方式
 * @type {number}
 */
export const TRIGGER_TYPE_FOCUS = 1 // 1 焦点触发
export const TRIGGER_TYPE_BLUR = 2 // 2 失焦触发
export const TRIGGER_TYPE_BUTTON = 3 // 3 按钮触发

/**
 * 消息类型
 * @type {string}
 */
export const MESSAGE_TYPE_IS_BINDING = 1000
export const MESSAGE_TYPE_NOT_BIND = 1001
export const MESSAGE_TYPE_REFRESH_DATA = 1200 // 刷新数据消息
export const MESSAGE_TYPE_PLUGIN_RESULT = 1300 // 插件执行结果消息
export const MESSAGE_TYPE_UPDATE_FORM = 1400 // 更新表单数据消息
export const MESSAGE_TYPE_UPDATE_MIX_FORM = 1500 // 更新表单数据消息
export const MESSAGE_TYPE_UPDATE_MIX_FORM_UPLOAD = 1501 // 项目扫码上传图片
export const MESSAGE_TYPE_UPDATE_MIX_FORM_IMAGE = 1502 // android项目上传图片
export const MESSAGE_TYPE_UPDATE_COMPANY = 1600 // 团队信息变更消息（app变化，组织架构变化）
export const MESSAGE_TYPE_TASK = 1700 // 任务通知
export const MESSAGE_TYPE_EXCEL_IMPORT_SUC = 1701 // 导入成功
export const MESSAGE_TYPE_DATA = 'DATA' //  更新数据
export const MESSAGE_TYPE_APPEND = 'APPEND' //  追加数据
export const MESSAGE_TYPE_SIGNATURE = 'SIGNATURE' //  签名
export const MESSAGE_TYPE_UPLOAD_IMAGE = 'UPLOAD_IMAGE' //  手机传图

/**
 * 刷新消息类型
 * @type {string}
 */
export const MESSAGE_REFRESH_TYPE_EXPORT = 'EXPORT' //  打印、导出
export const MESSAGE_REFRESH_TYPE_CONTACTS = 'CONTACTS' //  通讯录
export const MESSAGE_REFRESH_TYPE_TODO = 'TODO' //  我的待办
export const MESSAGE_REFRESH_TYPE_WORKBENCH = 'WORKBENCH' //  工作台
export const MESSAGE_REFRESH_TYPE_REMIND = 'REMIND'  // 催办

// button按钮控件点击类型
export const BUTTON_TYPE_PLUGIN = 'PLUGIN'    // 操作插件
export const BUTTON_TYPE_APPLY_FORM = 'FORM'  // 发起表单

// 插件赋值模式
export const CHOOSE_TYPE_MAIN_MAIN = 'MAIN_2_MAIN' // 普通
export const CHOOSE_TYPE_SUB_SUB = 'SUB_2_SUB' // 关联到下拉框or复选框
